export default "__VITE_ASSET__Dbrh6gm8__"